export default __webpack_public_path__ + "static/media/Candy.82b9a196.jpg";